import styled, { css } from "styled-components";

import { Palette } from "./theme";

const TypographyStyles = css`
    &.aevi-text {
        font-family: "RobotoLight";
        font-size: 11pt;
        font-weight: 400;
        line-height: 28pt;
        color: ${Palette.AeviBlack};
    }

    &.aevi-label {
        font-family: "RobotoLight";
        font-size: 12pt;
        font-weight: 100;
        line-height: 18pt;
        color: ${Palette.AeviBlack};
        text-align: right;
    }

    &.aevi-brand-text {
        font-family: "AeviFont";
        font-size: 16pt;
        font-weight: 100;
        line-height: 32pt;
        margin-left: 10pt;
        padding-top: 11pt;
        color: ${Palette.HeroGreen};
    }

    &.aevi-title {
        font-family: "AeviFont";
        font-size: 24pt;
        font-weight: 400;
        line-height: 32pt;
        color: ${Palette.AeviBlack};
        margin-top: 0;
    }
`;

export const TextStyle = styled.p.attrs(() => ({ className: "aevi-text" }))`
    ${TypographyStyles};
`;

export const BrandTextStyle = styled.div.attrs(() => ({ className: "aevi-brand-text" }))`
    ${TypographyStyles};
`;

export const TitleStyle = styled.h1.attrs(() => ({ className: "aevi-title" }))`
    ${TypographyStyles};
`;
